import { getOfficeListingsSelector, makeNullSafeDomainGetter, createIsLoadingSelector } from './common';
import { flow } from 'lodash';
import { createSelector } from 'reselect';

const officeListingsSelector = makeNullSafeDomainGetter(getOfficeListingsSelector, 'getOfficeListings');

export const residentialOfficeListingsSelector = flow(officeListingsSelector, (data) => data && data.residential ? data.residential : []);
export const commercialOfficeListingsSelector = flow(officeListingsSelector, (data) => data && data.commercial ? data.commercial : []);

export const combinedMarketplaceOfficeListingsSelector = createSelector([
  residentialOfficeListingsSelector,
  commercialOfficeListingsSelector,
], (residential, commercial) => [ ...residential, ...commercial ]);

export const officeListingsLoadingSelector = createIsLoadingSelector(getOfficeListingsSelector);
